/**
 * How a visit began (P2 design §4.5 entry source), from the page it started on: an alert
 * email link (`?src=alert`, which the notifier adds), a copy link (`/copy/:id`), a forecast
 * deep or share link (`?forecast=`), or direct.
 */
import { matchCopyRoute } from "../copyLinks/route.js";

/** @param {{pathname: string|null, declared: string|null, forecastParam: string|null}} page */
export function entrySourceOf({ pathname, declared, forecastParam }) {
  if (declared === "alert") return "alert";
  if (pathname && matchCopyRoute(pathname) !== null) return "copy_link";
  if (forecastParam) return "link";
  return "direct";
}
